import en from "./locale/en.mjs";
export var CookieType = /* @__PURE__ */ ((CookieType2) => {
  CookieType2["NECESSARY"] = "necessary";
  CookieType2["OPTIONAL"] = "optional";
  return CookieType2;
})(CookieType || {});
export const DEFAULTS = {
  barPosition: "bottom-full",
  closeModalOnClickOutside: false,
  colors: {
    barBackground: "#000",
    barButtonBackground: "#fff",
    barButtonColor: "#000",
    barButtonHoverBackground: "#333",
    barButtonHoverColor: "#fff",
    barTextColor: "#fff",
    checkboxActiveBackground: "#000",
    checkboxActiveCircleBackground: "#fff",
    checkboxDisabledBackground: "#ddd",
    checkboxDisabledCircleBackground: "#fff",
    checkboxInactiveBackground: "#000",
    checkboxInactiveCircleBackground: "#fff",
    controlButtonBackground: "#fff",
    controlButtonHoverBackground: "#000",
    controlButtonIconColor: "#000",
    controlButtonIconHoverColor: "#fff",
    focusRingColor: "#808080",
    modalBackground: "#fff",
    modalButtonBackground: "#000",
    modalButtonColor: "#fff",
    modalButtonHoverBackground: "#333",
    modalButtonHoverColor: "#fff",
    modalOverlay: "#000",
    modalOverlayOpacity: 0.8,
    modalTextColor: "#000",
    modalUnsavedColor: "#fff"
  },
  cookies: {
    necessary: [],
    optional: []
  },
  cookieExpiryOffsetMs: 1e3 * 60 * 60 * 24 * 365,
  // one year
  cookieNameIsConsentGiven: "ncc_c",
  cookieNameCookiesEnabledIds: "ncc_e",
  cookieOptions: {
    path: "/"
  },
  isAcceptNecessaryButtonEnabled: true,
  isControlButtonEnabled: true,
  isCookieIdVisible: false,
  isCssEnabled: true,
  isCssPonyfillEnabled: false,
  isDashInDescriptionEnabled: true,
  isIframeBlocked: false,
  isModalForced: false,
  locales: ["en"],
  localeTexts: { en }
};
